import { DestroyRef, Injectable, signal, TemplateRef, WritableSignal } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ServicioBarraSuperior {
  tituloActual: WritableSignal<string> = signal('Bienvenido');
  iconoSvgTitulo: WritableSignal<string | null> = signal(null);

  contenidoPersonalizado: WritableSignal<TemplateRef<any> | null> = signal(null);
  accionAtras: WritableSignal<(() => void) | null> = signal(null);

  public menuLateralAbierto: WritableSignal<boolean> = signal(false);

  /**
   * Establece el título principal que se mostrará en la barra superior.
   * @param titulo El nuevo título.
   */
  setTitulo(titulo: string): void {
    this.tituloActual.set(titulo);
  }

  // Título con ícono SVG del módulo; el ícono se quita solo al destruirse la vista
  setTituloConIcono(titulo: string, icono: string, destroyRef: DestroyRef): void {
    this.setTitulo(titulo);
    this.iconoSvgTitulo.set(icono);
    destroyRef.onDestroy(() => this.iconoSvgTitulo.set(null));
  }

  /**
   * Establece el contenido personalizado (filtros, botones, etc.) 
   * que se mostrará en la sección izquierda de la barra.
   * @param template La referencia a la plantilla (TemplateRef) desde el componente del módulo, o null para quitarlo.
   */
  setContenidoPersonalizado(template: TemplateRef<any> | null): void {
    this.contenidoPersonalizado.set(template);
  }

  /**
   * Limpia el título y el contenido personalizado (útil al salir de un módulo).
   */
  limpiarBarra(): void {
    this.setTitulo('');
    this.iconoSvgTitulo.set(null);
    this.setContenidoPersonalizado(null);
    this.accionAtras.set(null);
  }

  public readonly refreshWaSaldo$ = new Subject<void>();

  public refrescarSaldoWA(): void {
    this.refreshWaSaldo$.next();
  }

  public toggleMenuLateral(): void {
    this.menuLateralAbierto.update(valor => !valor);
  }

  public cerrarMenuLateral(): void {
    this.menuLateralAbierto.set(false);
  }
}
